import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

import { DateInput } from 'atoms/date-input';
import Dropdown from 'atoms/dropdown';
import { getOpenHoursArray } from 'util';

import { convertDowIndex } from '../util';

export default function SlotSelector({
  selectedTimeSlot,
  setSelectedTimeSlot,
}) {
  const locations = useSelector((state) => state.provider.locations);
  const providerLocation = locations[0];
  const [dowsWithAvailability, setDowsWithAvailability] = useState([]);
  const [availability, setAvailability] = useState({});

  useEffect(() => {
    loadDowAvailability(selectedTimeSlot?.date);
  }, []);

  const loadDowAvailability = (date) => {
    const selectedDow = convertDowIndex(dayjs(date).day());
    const dowOpenDay = providerLocation?.hours.filter(
      (dowOpenHours) => dowOpenHours.dow.id === selectedDow
    )[0];

    if (!dowOpenDay) {
      setDowsWithAvailability([...dowsWithAvailability, selectedDow]);
      return;
    }

    const dowOpenTimes = dowOpenDay.time;
    if (!dowsWithAvailability.includes(selectedDow)) {
      const calendarPerDow = { [selectedDow]: getOpenHoursArray(dowOpenTimes) };
      setAvailability({ ...availability, ...calendarPerDow });
      setDowsWithAvailability([...dowsWithAvailability, selectedDow]);
    }
  };

  const getAvailabilityItems = (selectedDate) => {
    if (selectedDate === dayjs().format('YYYY-MM-DD')) {
      const dowAvailability =
        availability[convertDowIndex(dayjs(selectedDate).day())];
      const todayAvailability = dowAvailability?.filter((time) =>
        dayjs(time, 'h:mma').isAfter(dayjs())
      );
      return todayAvailability ?? [];
    }
    return availability[convertDowIndex(dayjs(selectedDate).day())] ?? [];
  };

  const onChangeDateSelection = (dateSelected) => {
    loadDowAvailability(dateSelected);
    setSelectedTimeSlot({ timeStart: '', date: dateSelected });
  };

  const onSelectTime = (timeSelected) => {
    const formattedTime = dayjs(timeSelected, 'h:mma').format('HH:mm:ss');
    setSelectedTimeSlot({
      ...selectedTimeSlot,
      timeStart: formattedTime,
    });
  };

  return (
    <div className="flex-row">
      <DateInput
        className="mr-15 w-50"
        placeholder="Date"
        onChange={(date) => onChangeDateSelection(date)}
        value={selectedTimeSlot.date || ''}
        minDate={dayjs()}
        size="small"
      />
      <Dropdown
        placeholder={
          availability[convertDowIndex(dayjs(selectedTimeSlot.date).day())]
            ? 'Select time'
            : 'No times available'
        }
        className="w-50"
        items={getAvailabilityItems(selectedTimeSlot.date)}
        generateKey
        disableDropdown={
          !availability[convertDowIndex(dayjs(selectedTimeSlot.date).day())]
        }
        onClick={(time) => onSelectTime(time)}
        value={
          selectedTimeSlot.timeStart
            ? dayjs(selectedTimeSlot.timeStart, 'HH:mm:ss').format('h:mma')
            : ''
        }
        size="small"
      />
    </div>
  );
}
